import React from 'react';
import './landowner.scss';
import LandownerResults from './LandownerResults';
import Scrollable from '../../../components/scrollable/Scrollable';

const Landowner = () => {
  return (
    <div className="identifytool_wrapper">
      <Scrollable
        additionalClassName="tooldialog__wrapper-content landowner"
        scrollAdditionClassName="tooldialog__wrapper-content--scrollable"
      >
        <LandownerResults />
      </Scrollable>
    </div>
  );
};

export default Landowner;
